import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem('admin_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authApi = {
  login: (data: { email: string; password: string }) => api.post('/login', data),
  me: () => api.get('/me'),
};

export const adminApi = {
  dashboard: () => api.get('/admin/dashboard'),
  users: (params?: Record<string, string>) => api.get('/admin/users', { params }),
  userDetail: (id: number) => api.get(`/admin/users/${id}`),
  userReset: (id: number) => api.post(`/admin/users/${id}/reset`),
  accounting: (from: string, to: string) => api.get('/admin/accounting', { params: { from, to } }),
  billing: () => api.get('/admin/billing'),
  posts: (params?: Record<string, string | number>) => api.get('/admin/posts', { params }),
  disputes: () => api.get('/admin/disputes'),
  getSettings: () => api.get('/admin/settings'),
  updateSettings: (settings: Record<string, string | number>) => api.patch('/admin/settings', { settings }),
  invoices: () => api.get('/admin/admin-invoices'),
  adminInvoices: (from: string, to: string) => api.get('/admin/admin-invoices', { params: { from, to } }),
  createAdminInvoice: (formData: FormData) => api.post('/admin/admin-invoices', formData),
  deleteAdminInvoice: (id: number) => api.delete(`/admin/admin-invoices/${id}`),
  downloadAdminInvoice: (id: number, type: 'pdf' | 'xml') => api.get(`/admin/admin-invoices/${id}/file/${type}`, { responseType: 'blob' }),
  invoiceUpload: (formData: FormData) => api.post('/admin/admin-invoices', formData),
  invoiceDelete: (id: number) => api.delete(`/admin/admin-invoices/${id}`),
  invoiceDownload: (id: number, type: 'pdf' | 'xml') => api.get(`/admin/admin-invoices/${id}/file/${type}`, { responseType: 'blob' }),
};

export default api;
